import React from "react";
import { Route } from "react-router-dom";

import SchoolLayout from "apps/school-site/layouts/SchoolLayout";
import SchoolHomePage from "apps/school-site/pages/SchoolHomePage";

// Szkoła
// Dokumenty i Procedury
import StatutesPage from "apps/school-site/pages/statutes/StatutesPage";
import StandardsPage from "apps/school-site/pages/standards/StandardsPage";
import RodoPage from "apps/school-site/pages/rodo/RodoPage";
import AccessibilityPage from "apps/school-site/pages/accessibility/AccessibilityPage";
import TendersPage from "apps/school-site/pages/tenders/TendersPage";
// Szkoła
// Wsparcie
import PedagoguePage from "apps/school-site/pages/pedagogue/PedagoguePage";
import HealthPage from "apps/school-site/pages/health/HealthPage";
import InsurancePage from "apps/school-site/pages/insurance/InsurancePage";

// Szkoła
// Projekty
import ProjectsPage from "apps/school-site/pages/projects/ProjectsPage";
import ErasmusPage from "apps/school-site/pages/projects/erasmus/ErasmusPage";
import QualificationsProjectPage from "apps/school-site/pages/projects/qualifications/QualificationsProjectPage";
import RemoteWyrzyskProjectPage from "apps/school-site/pages/projects/remote-wyrzysk/RemoteWyrzyskProjectPage";
import InternshipSpecialistProjectPage from "apps/school-site/pages/projects/internship-specialist/InternshipSpecialistProjectPage";

// Aktualności
import NewsPage from "apps/school-site/pages/news/NewsPage";
import NewsDetailsPage from "apps/school-site/pages/news/NewsDetailsPage";

//Uczeń 
import AnnouncementsPage
  from "apps/school-site/pages/announcements/AnnouncementsPage";
import AnnouncementDetailsPage
  from "apps/school-site/pages/announcements/AnnouncementDetailsPage";


import RetakeExamsPage from "apps/school-site/pages/student/retake-exams/RetakeExamsPage";
import MaturaPage from "apps/school-site/pages/student/matura/MaturaPage";
import StudentDocumentsPage from "apps/school-site/pages/student/documents/StudentDocumentsPage";
import MLegitymacjaPage from "apps/school-site/pages/student/mlegitymacja/MLegitymacjaPage";
// Kandydat
import CandidatePage from "apps/school-site/pages/candidate/CandidatePage";
// Rodzic
import ParentPage from "apps/school-site/pages/parent/ParentPage";
// Nauczyciel
import TeacherPage from "apps/school-site/pages/teacher/TeacherPage";
// Kontakt
import ContactPage from "apps/school-site/pages/contact/ContactPage";
// Kierunki kształcenia
import EducationDirectionPage from "apps/school-site/features/education-direction/pages/EducationDirectionPage";


export default function SchoolRoutes({ state }) {
  return (
    <>
      <Route element={<SchoolLayout />}>
        <Route
          index
          element={<SchoolHomePage state={state} />}
        />
        <Route
          path="/direction/:branchSymbol"
          element={<EducationDirectionPage />}
        />
        {/* Szkoła */}
        {/* Dokumenty i Procedury */}
        <Route
          path="statutes"
          element={<StatutesPage state={state} />}
        />
        <Route
          path="standards"
          element={<StandardsPage state={state} />}
        />
        <Route
          path="rodo"
          element={<RodoPage state={state} />}
        />
        <Route
          path="accessibility"
          element={<AccessibilityPage state={state} />}
        />
        <Route
          path="tenders"
          element={<TendersPage state={state} />}
        />
        {/* Szkoła */}
        {/* Wsparcie */}
        <Route
          path="pedagogue"
          element={<PedagoguePage state={state} />}
        />
        <Route
          path="health"
          element={<HealthPage state={state} />}
        />
        <Route
          path="insurance"
          element={<InsurancePage state={state} />}
        />
        {/* Szkoła */}
        {/* Projekty */}
        <Route
          path="projects/erasmus"
          element={<ErasmusPage state={state} />}
        />
        <Route
          path="projects/wklp"
          element={<QualificationsProjectPage state={state} />}
        />
        <Route
          path="projects/zdalny-wyrzysk"
          element={<RemoteWyrzyskProjectPage state={state} />}
        />
        <Route
          path="projects/od-stazysty-do-specjalisty"
          element={<InternshipSpecialistProjectPage state={state} />}
        />
        <Route
          path="projects"
          element={<ProjectsPage state={state} />}
        />
        {/* Aktualności */}
        <Route
          path="news"
          element={<NewsPage state={state} />}
        />

        <Route
          path="news/:postId"
          element={<NewsDetailsPage />}
        />

        {/* Nauczyciel */}
        <Route
          path="teacher"
          element={<TeacherPage state={state} />}
        />

        {/* Rodzic */}
        <Route
          path="parent"
          element={<ParentPage state={state} />}
        />

        {/* Ogłoszenia */}
        <Route
          path="announcements"
          element={<AnnouncementsPage />}
        />

        <Route
          path="announcements/:postId"
          element={<AnnouncementDetailsPage />}
        />
        {/* Uczeń */}
        {/* Informacje dla ucznia */}
        {/* <Route
          path="student/retake-exams"
          element={
            <AnnouncementsPage
              categorySlug="egzaminy-poprawkowe"
              title="Egzaminy poprawkowe"
              description="Aktualne informacje dotyczące egzaminów poprawkowych."
              limit={1}
            />
          }
        /> */}
        <Route
          path="student/retake-exams"
          element={<RetakeExamsPage />}
        />
        <Route
          path="student/matura"
          element={<MaturaPage state={state} />}
        />

        <Route
          path="student/documents"
          element={<StudentDocumentsPage state={state} />}
        />

        <Route
          path="student/mlegitymacja"
          element={<MLegitymacjaPage state={state} />}
        />

        {/* Kandydat */}
        <Route
          path="candidate"
          element={<CandidatePage state={state} />}
        />
        
        {/* Kontakt */}
        <Route
          path="contact"
          element={<ContactPage state={state} />}
        />

        {/* itd. */}
      </Route>
    </>
  );
}